export function getCoordInBetween(
  x: google.maps.LatLngLiteral,
  y: google.maps.LatLngLiteral
): google.maps.LatLngLiteral {
  return {
    lat: (x.lat + y.lat) / 2,
    lng: (x.lng + y.lng) / 2,
  };
}
